import { render, staticRenderFns } from "./RegistrarSignosDialog.vue?vue&type=template&id=3818b83e&"
import script from "./RegistrarSignosDialog.vue?vue&type=script&lang=js&"
export * from "./RegistrarSignosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports